export default {
    // 之前的
    SET_REPAIRCONF: (state, repairConf) => {
        state.repairConf = repairConf
    },
    SET_FLOWCONF: (state, flowConf) => {
        state.flowConf = flowConf
    },
    SET_SIGNCLASS: (state, signClass) => {
        console.log(signClass)
        state.signClass = signClass
    },
    SET_SIGNQUERY: (state, sighQuery) => {
        state.sighQuery = sighQuery
    },
    // 智能门锁设备管理=》选择楼栋页面显示基础设置按钮
    SET_SHOW_BASE_BTN(state, IsShowBaseSetBtn) {
        state.IsShowBaseSetBtn = IsShowBaseSetBtn
    },
    SET_FLAT_ID(state, flatId) {
        state.SchoolFlatId = flatId
    },
    // 基础数据 => 服务大厅===========================================
    // 获取大厅全部数据
    GET_OVER_ALL(state, obj) {
        let { PageBasicData, PageModuleList, newAddId } = obj
        state.PageBasicData = PageBasicData
        state.PageModuleList = PageModuleList || []
        if (newAddId) {
            state.CurrentModifyData['id'] = obj.newAddId
        }
    },
    // 添加新组件
    ADD_MODULE(state, moduleData) {
        state.PageModuleList.push(moduleData)
        state.CurrentModifyType = moduleData.assemblyType
        state.CurrentModifyData = moduleData
    },
    // 点击页面编辑icon
    CLICK_EDIT_ICON(state, data) {
        state.CurrentModifyType = 0
        state.PageBasicData = data
    },
    // 点击组件赋值
    CLICK_MODULE(state, moduleData) {
        state.CurrentModifyType = moduleData.assemblyType
        state.CurrentModifyData = moduleData
    },
    // 删除组件
    DEL_MODULE(state, obj) {
        let { moduleList, lastModIdx } = obj
        if (lastModIdx >= 0) {
            state.CurrentModifyType = moduleList[lastModIdx].assemblyType
            state.CurrentModifyData = moduleList[lastModIdx]
        } else {
            state.CurrentModifyType = 0
        }
        state.PageModuleList = moduleList
    },

    // 是否有管理权限
    CHANGE_IS_ADMIN(state, val) {
        state.IsAdmin = val
    },
}
